import Image from 'next/image';
import styles from './bannerCard.module.scss';
import { PostType } from 'types';
import { PATH } from 'data';
import { AppLinkComp } from 'components';

function BannerCardComp(props: { data: PostType<'list'> }) {
    const image = props.data.banner?.file ?? props.data.main_image?.file ?? props.data.gallery?.at(0)?.file;
    return (
        <AppLinkComp className={`${styles['banner-layout']}`} href={PATH.postDetail(props.data.slug)}>
            {image?.length ? <Image src={image} width={545} height={189} alt="banner" /> : null}
            {/* <div className={`${styles['lovely']} d-flex center-content g-1`}>
                <p className="t-p3 t-black1">{props.data.likes_count}</p>
                <FaHeart size={14} color={COLORS.red} />
            </div> */}
            <div className={`${styles['info-layout']} d-flex center-content-y justify-content-between g-1`}>
                <div>
                    <p className="t-p1 t-500 t-l-white t-d-gray3">{props.data.title}</p>
                    {/* <p className="t-p3 t-500 t-l-white t-d-gray3 d-md-none">بازدید: {props.data.views_count}</p> */}
                </div>
                {/* <p className="t-p1 t-400 t-l-white t-d-gray3">شماره تماس: 09163254847</p> */}
            </div>
        </AppLinkComp>
    );
}

export default BannerCardComp;
